export const BULK_ADD_LIMIT = 5000;
export const FOOTER_ACTIONS_HEIGHT = 65;
export const MAX_REGEX_CAPTURE_GROUPS = 3;
export const PAGE_SIZE = 50;
